// extracted by mini-css-extract-plugin
export default {"dash":"Dash_dash__vBBtB"};